module.exports = __webpack_public_path__ + "static/media/MacbookPro.bf02f453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/MacbookPro.png
// module id = 802
// module chunks = 1 3